// Adapted from https://github.com/vercel/next.js/blob/canary/examples/with-sentry/utils/sentry.js

import * as Sentry from "@sentry/node";

function replaceFilename(filename: string | undefined): string | undefined {
  try {
    if (!filename) {
      return filename;
    }

    if (
      process.env.NEXT_IS_SERVER === "true" &&
      process.env.NEXT_PUBLIC_SENTRY_SERVER_ROOT_DIR
    ) {
      // For Node.js, rewrite Error.stack to use relative paths, so that source
      // maps starting with ~/_next map to files in Error.stack with path
      // app:///_next

      return filename
        .replace(process.env.NEXT_PUBLIC_SENTRY_SERVER_ROOT_DIR, "app:///")
        .replace(".next", "_next");
    }

    if (process.env.NEXT_IS_SERVER === "false") {
      return decodeURI(filename);
    }

    return filename;
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export const init = () => {
  if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
    Sentry.init({
      dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
      enabled: process.env.NODE_ENV === "production",
      release: process.env.NEXT_PUBLIC_COMMIT_SHA,
      environment: process.env.EVERGIVING_ENVIRONMENT,
      integrations: [
        Sentry.rewriteFramesIntegration({
          iteratee: (frame: any) => ({
            ...frame,
            filename: replaceFilename(frame.filename),
          }),
        }),
      ],
    });
    Sentry.setContext("form", {
      campaign_uuid: process.env.DIGITAL_FORM_CAMPAIGN_UUID,
      version_token: process.env.DIGITAL_FORM_VERSION_TOKEN,
    });
  }
};
